import React, { useState, useCallback } from "react";
import { AppProvider, Tabs, LegacyCard } from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import CsvImportExport from "./CsvImportExport";
import { useLibrary } from "./LibraryContext";

export default function Library() {
  const [selectedTab, setSelectedTab] = useState(0);
  const { refreshFabrics, refreshLinings, refreshTshirtFabrics } = useLibrary();

  const tabs = [
    {
      id: "fabric-numbers",
      content: "Fabric Numbers",
      accessibilityLabel: "Fabric Numbers",
      panelID: "fabric-numbers-panel",
    },
    {
      id: "lining-numbers",
      content: "Lining Numbers",
      accessibilityLabel: "Lining Numbers",
      panelID: "lining-numbers-panel",
    },
    {
      id: "tshirt-polo-fabric",
      content: "T-Shirt & Polo Fabric",
      accessibilityLabel: "T-Shirt & Polo Fabric",
      panelID: "tshirt-polo-fabric-panel",
    },
  ];

  const handleTabChange = useCallback((selectedTabIndex) => {
    setSelectedTab(selectedTabIndex);
  }, []);

  return (
    <AppProvider i18n={en}>
      <div className="button_option">
        <h2>Library</h2>
      </div>

      <LegacyCard>
        <Tabs tabs={tabs} selected={selectedTab} onSelect={handleTabChange}>
          <div style={{ padding: 16 }}>
            {selectedTab === 0 && (
              <CsvImportExport
                title="Fabric Numbers"
                csvField="fabricNumber"
                apiBase="/api/fabrics"
                payloadKey="fabrics"
                exportFilename="fabric-export"
                onImportSuccess={refreshFabrics}
              />
            )}
            {selectedTab === 1 && (
              <CsvImportExport
                title="Lining Numbers"
                csvField="liningNumber"
                apiBase="/api/linings"
                payloadKey="linings"
                exportFilename="lining-export"
                onImportSuccess={refreshLinings}
              />
            )}
            {selectedTab === 2 && (
              <CsvImportExport
                title="T-Shirt & Polo Fabric"
                csvField="fabricNumber"
                apiBase="/api/tshirtFabrics"
                payloadKey="tshirtFabrics"
                exportFilename="tshirt-polo-fabric-export"
                onImportSuccess={refreshTshirtFabrics}
              />
            )}
          </div>
        </Tabs>
      </LegacyCard>
    </AppProvider>
  );
}
